import {SET_SECURITY_LEVELS} from "./types";
import Api from '../services/Api'

export const getSecurity = () => dispatch => {
    return Api.get(`/PermissionLevels`)
        .then(res => res.data)
        .then(res => {
            dispatch({
                type: SET_SECURITY_LEVELS,
                payload: res,
            });
        });
}


// WEBPACK FOOTER //
// ./src/actions/securityActions.js